import React from 'react';
import FuturesTrade from './FuturesTrade';
import { useNavigate, useParams } from 'react-router-dom';

const FuturesTradeWrap = () => {
    const { pairName } = useParams();
    const navigate = useNavigate();

    const handleNavigation = (newSymbol) => {
        // setOrderBookData(null);
        // popupState.close();
        navigate('/futures/trade/' + newSymbol);
    };
    return (
        <div>
            <h1 className='visually-hidden'>Futures Trade</h1>
            <FuturesTrade handleNavigation={handleNavigation} key={pairName} pairName={pairName} navigate={navigate} />
        </div>
    );
};

export default FuturesTradeWrap;